import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBooking = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.12503 4.37499V3.43749C8.12503 2.94 7.68553 2.5 7.18753 2.5C6.66004 2.5 6.25004 2.9395 6.25004 3.43749V4.37499H4.84355C4.47061 4.37512 4.113 4.52336 3.84934 4.78711C3.58568 5.05087 3.43756 5.40854 3.43756 5.78148V7.18747H16.5625V5.78148C16.5625 5.01998 15.918 4.37499 15.156 4.37499H13.75V3.43749C13.75 2.94 13.3105 2.5 12.8125 2.5C12.285 2.5 11.875 2.9395 11.875 3.43749V4.37499H8.12503ZM16.5625 8.12496H3.43756L3.43806 16.0939C3.43571 16.2792 3.47047 16.4631 3.5403 16.6347C3.61012 16.8064 3.7136 16.9623 3.84463 17.0933C3.97566 17.2244 4.13159 17.3278 4.30323 17.3977C4.47488 17.4675 4.65876 17.5022 4.84405 17.4999H15.156C15.5289 17.4999 15.8866 17.3518 16.1503 17.0881C16.4141 16.8245 16.5623 16.4668 16.5625 16.0939V8.12496ZM14.046 10.9724C14.2684 10.7501 14.2684 10.3891 14.046 10.1667H14.0478C13.8255 9.94442 13.4645 9.94442 13.2421 10.1667L9.09102 14.3161L7.21644 12.4433C6.99412 12.221 6.63308 12.221 6.41076 12.4433C6.18845 12.6656 6.18845 13.0266 6.41076 13.249L8.68729 15.5255C8.90961 15.7478 9.27066 15.7478 9.49297 15.5255L14.046 10.9724Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	})
});
export default SvgBooking;
